$(function() {
	var $hideable_messages = $('.hideable-message');

	if( $hideable_messages.length == 0 ) {
		return;
	}

	window.setTimeout(function(){
		$hideable_messages.fadeOut();
	}, 2000);
});